function LibraryBanner() {
  return (
    <>
      <section className="innerBannerWrapper">
        <img src="assets/images/product-close-banner.webp" alt="" />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="txt-white titleMain text-center">
                Experience Our Showcase
              </h2>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default LibraryBanner;
